import React, { ChangeEvent, FC, useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";
import { InsertLinkPopup } from "./InsertLinkPopup";
import { AttributeDescriptionContainer, DescriptionTextarea } from "./styled";

export type AttributeDescriptionProps = {
  description?: string;
  onChangeDescription: (description: string) => void;
};

export const AttributeDescription: FC<AttributeDescriptionProps> = ({ description, onChangeDescription }) => {
  const { t } = useTranslation("dialogs");
  const positionRef = useRef<number>(0);
  const onLinkInsert = useCallback(
    (linkText: string, link: string) => {
      const formattedLink = `[${linkText}](${link})`;
      const cursorPosition = positionRef.current || description.length;
      const newDescription =
        description.substring(0, cursorPosition) +
        formattedLink +
        description.substring(cursorPosition, description.length);

      onChangeDescription(newDescription);
    },
    [description, onChangeDescription],
  );
  const onChange = useCallback(
    (event: ChangeEvent<HTMLTextAreaElement>) => {
      onChangeDescription(event.target.value);
    },
    [onChangeDescription],
  );
  const onBlur = useCallback(event => {
    positionRef.current = event.target.selectionStart;
  }, []);

  return (
    <AttributeDescriptionContainer>
      <InsertLinkPopup onApply={onLinkInsert} />
      <DescriptionTextarea
        label={t("dialogComponents.attributeDescription")}
        placeholder={t("dialogComponents.inputDescription")}
        value={description}
        onChange={onChange}
        onBlur={onBlur}
        minHeight={64}
        autoResize
      />
    </AttributeDescriptionContainer>
  );
};
